<div class="ribbon-group">
  <div class="ribbon-group-content tx-tab-navigate" [ngClass]="{ 'txui-state-disabled': disabled }">
    <div class="mb-1 d-flex align-items-center gap-3">
      <div class="ribbon-checkbox">
        <div class="ribbon-checkbox-input-element-container">
          <input
            [disabled]="disabled"
            type="checkbox"
            id="unansweredOnly"
            (change)="onShowUnansweredOnlyChanged($event)" />
        </div>
        <!-- <div class="ribbon-button-small-label-container">
          <label class="ribbon-button-label" for="unansweredOnly">
            Show only
            <span id="unansweredCount">{{ unansweredCount }}</span>
            unanswered
          </label>
        </div> -->
        <div class="ribbon-button-small-label-container">
          <label class="ribbon-button-label" for="unansweredOnly">Skip answered</label>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center gap-1">
      <button [disabled]="disabled" type="button" id="prevBtn" class="flex-grow-1" (click)="previousClicked.emit()">
        <i class="bi bi-arrow-left"></i>
        Previous
      </button>
      <button [disabled]="disabled" type="button" id="nextBtn" class="flex-grow-1" (click)="nextClicked.emit()">
        Next
        <i class="bi bi-arrow-right"></i>
      </button>
    </div>
  </div>
  <div class="ribbon-group-label-container">
    <p class="ribbon-group-label">Navigate Fields</p>
  </div>
</div>
